import React from "react";
import "../styles/NotFoundPage.css";
import Head from "../components/Head";
import { Link, useNavigate } from 'react-router-dom';
import { scrollToTop } from '../hooks/useScrollToTop';

const NotFound = () => {
  const navigate = useNavigate();

  const handleHomeClick = (event) => {
    event.preventDefault();
    navigate('/');
    scrollToTop();
  };

  return (
    <div>
      <Head title="EssayWriter | 404" />
      <div className="notfound-container">
        <div className="notfound-wrapper">
          <div className="notfound-text">
            <h2>404</h2>
            <p>Sidan kunde inte hittas</p>
          </div>
          <div className="notfound-line-divider"></div>
          <div className="notfound-text">
            <p id="notfound-additional-text">
              Tyvärr, sidan du letar efter finns inte eller har flyttats.
            </p>
            <Link to="/" className="notfound-return-home-button" onClick={handleHomeClick}>
              Återgå till startsidan
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;